//

import { useEffect } from "react";
import { useSelector } from "react-redux";
import TableColumn from "../../../components/SharedComponent/TableColumnComponent/TableColumn";
import TableComponent from "../../../components/SharedComponent/TableComponent/TableComponent";
import { stopInProgressAutoRefresh } from "../../../redux/JobModule/InProgressPage/InProgressAction";
import { RootState } from "../../../redux/store";
import { useAppDispatch } from "../../../redux/useAppDispatch";

import CompletedActionColumn from "../../../components/JobModuleComponent/CompletedTabComponent/ActionColumnCompleted";
import AutoRefreshNewCompletedCheckbox from "../../../components/JobModuleComponent/CompletedTabComponent/AutoRefreshCompletedCheckbox";
import DownloadModal from "../../../components/SharedComponent/ModalComponent/DownloadModal";
import { stopArchivedAutoRefresh } from "../../../redux/JobModule/ArchivedPage/ArchivedAction";
import { fetchNewCompletedAudios, fetchPaginateNewCompletedAudios, resetNewCompletedTable, stopNewCompletedAutoRefresh, switchNewCompletedAutoFresh, updateNewCompletedRequestBody } from "../../../redux/JobModule/CompletedPage/NewCompletedAction";
import { closeDownloadModal, openDownloadModal } from "../../../redux/Transcribe/TranscribeAction";

function NewTabContent(props: any) {
  const dispatch = useAppDispatch();

  //Modal State Getting
  const downloadModalState = useSelector((state: RootState) => state.TranscribeState.downloadModalState);

  const completedPageState = useSelector((state: RootState) => state.NewCompletedAudiosState);
  const handleTableSorting = (sorter: any) => {
    const isAscend = (order: string) => {
      if (order === "ascend") {
        return true;
      }

      return false;
    };

    const newSortingRequestBody = {
      ...completedPageState.currentRequestBody,
      SortColumn: sorter.field,
      IsAsc: isAscend(sorter.order),
    };
    dispatch(stopNewCompletedAutoRefresh());
    dispatch(resetNewCompletedTable());
    dispatch(updateNewCompletedRequestBody(newSortingRequestBody));
    dispatch(fetchNewCompletedAudios({}));
    dispatch(switchNewCompletedAutoFresh({ autoRefresh: true }));
  };

  //Each rendering
  useEffect(() => {
    dispatch(fetchNewCompletedAudios({}));
    dispatch(switchNewCompletedAutoFresh({ autoRefresh: true }));

    return () => {
      dispatch(stopArchivedAutoRefresh());
      dispatch(stopNewCompletedAutoRefresh());
      dispatch(stopInProgressAutoRefresh());
      dispatch(resetNewCompletedTable());
    };
  }, []);

  const CompletedTableColumn = [
    ...TableColumn,
    {
      title: "Actions",
      key: "", //Need to add the key and dataIndex
      dataIndex: "",

      render: (value: any, record: any) => {
        return <CompletedActionColumn record={record} />;
      },
      width: 90,
    },
  ];

  return (
    <div className="body-container gap-3">
      <AutoRefreshNewCompletedCheckbox />
      <TableComponent
        columns={CompletedTableColumn}
        dataSource={completedPageState.data}
        pagination={completedPageState.pagination}
        handleTableSorting={handleTableSorting}
        fetchPaginatedData={() => fetchPaginateNewCompletedAudios({})}
        loading={completedPageState.loading}
        tableKey={"CompletedTab"}
      />

      <DownloadModal
        openState={downloadModalState}
        open={() => dispatch(openDownloadModal())}
        close={() => dispatch(closeDownloadModal())}
      />
    </div>
  );
}

export default NewTabContent;
